module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('h2', {
    staticClass: "chapter"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/title.jpg"
    }
  }), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/ack.htm"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/intro.htm"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/ch01.htm"
    }
  }, [_vm._v("CHAPTER 1: At Home")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/ch02.htm"
    }
  }, [_vm._v("CHAPTER 2: In the Workplace")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/ch03.htm"
    }
  }, [_vm._v("CHAPTER 3: On the Road")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/ch04.htm"
    }
  }, [_vm._v("CHAPTER 4: On Vacation")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/ch05.htm"
    }
  }, [_vm._v("CHAPTER 5: Eating Out")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/ch06.htm"
    }
  }, [_vm._v("CHAPTER 6: Entertaining")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/ch07.htm"
    }
  }, [_vm._v("CHAPTER 7: In Conversation")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/ch08.htm"
    }
  }, [_vm._v("CHAPTER 8: In Celebration")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/ch09.htm"
    }
  }, [_vm._v("CHAPTER 9: In Love")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/ch10.htm"
    }
  }, [_vm._v("CHAPTER 10: In Marriage")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/ch11.htm"
    }
  }, [_vm._v("CHAPTER 11: Parenthood")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/appa.htm"
    }
  }, [_vm._v("APPENDIX I: Tipping for Every Occasion")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/appb.htm"
    }
  }, [_vm._v("APPENDIX II: Sentiments for Every Occasion")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/index.htm"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/ata.htm"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33ef1ee3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/toc.vue
// module id = 72
// module chunks = 0